var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { AddOnServicesStatus } from "./AddOnServicesState";
import { ADD_ON_SERVICES_RESET_ACTION_TYPE, ADD_ON_SERVICES_FETCH_START_ACTION_TYPE, ADD_ON_SERVICES_FETCH_SUCCESS_ACTION_TYPE, ADD_ON_SERVICES_SAVE_START_ACTION_TYPE, ADD_ON_SERVICES_SAVE_SUCCESS_ACTION_TYPE, ADD_ON_SERVICES_DELETE_START_ACTION_TYPE, ADD_ON_SERVICES_DELETE_SUCCESS_ACTION_TYPE, ADD_ON_SERVICES_CHANGE_STATE_START_ACTION_TYPE, ADD_ON_SERVICES_CHANGE_STATE_SUCCESS_ACTION_TYPE, ADD_ON_SERVICES_ERROR_ACTION_TYPE, } from "../action/AddOnServicesActionsTypes";
var initialState = {
    services: [],
    status: AddOnServicesStatus.Initial,
    loading: false,
};
export var addOnServicesReducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ADD_ON_SERVICES_RESET_ACTION_TYPE:
            return __assign({}, initialState);
        case ADD_ON_SERVICES_FETCH_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: AddOnServicesStatus.Fetching, loading: true });
        case ADD_ON_SERVICES_FETCH_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: AddOnServicesStatus.FetchSuccess, services: __spreadArray([], action.payload.services, true), loading: false });
        case ADD_ON_SERVICES_SAVE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: AddOnServicesStatus.Saving, savedService: undefined, loading: true });
        case ADD_ON_SERVICES_SAVE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: AddOnServicesStatus.SaveSuccess, services: state.services.some(function (service) { return service.uuid === action.payload.service.uuid; }) ? state.services.map(function (service) { return service.uuid === action.payload.service.uuid ? __assign({}, action.payload.service) : service; }) : __spreadArray(__spreadArray([], state.services, true), [__assign({}, action.payload.service)], false), savedService: __assign({}, action.payload.service), loading: false });
        case ADD_ON_SERVICES_DELETE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: AddOnServicesStatus.Deleting, loading: true });
        case ADD_ON_SERVICES_DELETE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { services: state.services.filter(function (service) { return service.id !== action.payload.id; }), savedService: ((_a = state.savedService) === null || _a === void 0 ? void 0 : _a.id) === action.payload.id ? undefined : state.savedService, loading: false });
        case ADD_ON_SERVICES_CHANGE_STATE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: AddOnServicesStatus.ChangingState, loading: true });
        case ADD_ON_SERVICES_CHANGE_STATE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { services: state.services.map(function (service) { return service.uuid === action.payload.service.uuid ? __assign({}, action.payload.service) : service; }), savedService: ((_b = state.savedService) === null || _b === void 0 ? void 0 : _b.uuid) === action.payload.service.uuid ? action.payload.service : state.savedService, status: AddOnServicesStatus.ChangeStateSuccess, loading: false });
        case ADD_ON_SERVICES_ERROR_ACTION_TYPE:
            return __assign(__assign({}, state), { status: AddOnServicesStatus.Error, loading: false });
        default:
            return state;
    }
};
export default addOnServicesReducer;
